import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {Dot} from '../../../../components/dot/dot';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';
import {TimesheetStatusSelect, TimesheetStatusService} from '../../../../../api';
import {QueryKey} from '../../../../constants/query-key';

@Component({
  selector: 'elcia-timesheet-status-dropdown',
  imports: [Dot, Dropdown, MultiDropdown, TranslatePipe],
  templateUrl: './timesheet-status-dropdown.html',
  styleUrl: './timesheet-status-dropdown.scss',
})
export class TimesheetStatusDropdown {
  private readonly timesheetStatusService = inject(TimesheetStatusService);

  public isMulti = input.required<boolean>();
  control = input.required<FormControl>();

  private readonly statusesQuery = injectQuery(() => ({
    queryKey: [QueryKey.TIMESHEET_STATUSES_SELECT],
    queryFn: () => lastValueFrom(this.timesheetStatusService.getTimesheetStatusSelect()),
  }));

  protected readonly options = computed<TimesheetStatusSelect[]>(
    () => this.statusesQuery.data()?.timesheetStatuses ?? [],
  );
}
